// extracted by mini-css-extract-plugin
export default {"benefitTable":"Benefit_benefitTable__VDcb0","headerWrapper":"Benefit_headerWrapper__5uHif","contentWrapper":"Benefit_contentWrapper__PXSbT"};